import Script from 'next/script'
import { useEffect } from 'react'

import { useAdminContext } from '~/components/hooks/useAdminContext'
import { useCurrentUser } from '~/components/hooks/useCurrentUser'
import { useFirm } from '~/components/hooks/useFirm'
import { isProd } from '~/util/env'
import { avatarSidToUrl } from '~/util/s3'

const APP_ID = '9da9efc8-fee1-4217-8364-7e50322fd1e4'

declare global {
  interface Window {
    Pylon: (command: string, callback?: (count: number) => void) => void
    pylon: {
      chat_settings: {
        app_id: string
        email: string
        name: string
        avatar_url: string | undefined
        account_external_id: string
        email_hash: string | undefined
      }
    }
  }
}

export function PylonWrapper({ children }: { children: React.ReactNode }) {
  const user = useCurrentUser()
  const { isImpersonating } = useAdminContext()
  const firm = useFirm()

  const shouldShowPylon = isProd && (!isImpersonating || user.isCustomerSuccess)

  useEffect(() => {
    if (!shouldShowPylon) {
      return
    }
    const avatarUrl = user.avatarSid ? avatarSidToUrl(user.avatarSid) : undefined
    window.pylon = {
      chat_settings: {
        app_id: APP_ID,
        email: user.email,
        name: user.fullName,
        avatar_url: avatarUrl,
        email_hash: user.pylonEmailHash ?? undefined,
        account_external_id: firm.sid,
      },
    }
  }, [user, firm, shouldShowPylon])

  return shouldShowPylon ? (
    <>
      <Script
        id="pylon-chat"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(){var e=window;var t=document;var n=function(){n.e(arguments)};n.q=[];n.e=function(e){n.q.push(e)};e.Pylon=n;var r=function(){var e=t.createElement("script");e.setAttribute("type","text/javascript");e.setAttribute("async","true");e.setAttribute("src","https://widget.usepylon.com/widget/${APP_ID}");var n=t.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};if(t.readyState==="complete"){r()}else if(e.addEventListener){e.addEventListener("load",r,false)}})();
          `,
        }}
      />
      {children}
    </>
  ) : (
    <>{children}</>
  )
}
